import type { OrgRow, ProjectHome } from "@/lib/api";

export type ProjectScopeListItem = { id: string; slug: string; name: string };

/** Derive org label + switcher list from GET …/home (no GET /api/o/:org). */
export function projectScopeFromHome(home: ProjectHome): {
  org: OrgRow;
  projects: ProjectScopeListItem[];
} {
  const projects =
    home.accessible_projects && home.accessible_projects.length > 0
      ? home.accessible_projects
      : [home.project];
  return { org: home.org, projects };
}

export function projectHomeIsNonEmpty(home: ProjectHome | null): boolean {
  return Boolean(home?.project?.slug && home.role);
}
